/**
 * Creates and returns a debounced version of the passed function.
 * The debounced function will postpone its execution until after `wait` milliseconds have elapsed since the last time it was invoked.
 *
 * @param {Function} func - The function to debounce.
 * @param {number} wait - The number of milliseconds to delay.
 * @returns {Function} - Returns the new debounced function.
 */
import $ from 'jquery';
import {pythonGenerator} from "blockly/python";
export function debounce(func, wait) {
    let timeout;
    return function () {
        const context = this,
            args = arguments;
        const later = function () {
            timeout = null;
            func.apply(context, args);
        };
        clearTimeout(timeout);
        timeout = setTimeout(later, wait);
    };
}
export function getDatasetChoices(choices_list=true){
    var options = [["Select a dataset", "null"]];
    $.ajax({
        type: "GET",
        url: '/api/',
        async: false,
        success: function(data) {
            if (choices_list === true) {
                for (var i = 0; i < data.length; i++) {
                    if (data[i].name !== undefined && data[i].name !== null && data[i].name !== "") {
                        options.push([data[i].name, data[i].definition]);
                    }
                }
                return options;
            }
            else if (choices_list === false) {
                options = data
                return data.results;
            }
        },
        error: function(data) {
            return data;
        }
    })
    return options

}
export function getDatasetFields(url, callback=null){
    if(url === "null" || !url){
        return [["Select a field 1", "null"]];
    }
    var options = [];
    $.ajax({
        type: "GET",
        url: url,
        async: false,
        success: function (data) {

            for (var i = 0; i < data.fields.length; i++) {
                if (data.fields[i].name !== undefined && data.fields[i].name !== null && data.fields[i].name !== "") {
                    options.push([data.fields[i].name, data.fields[i].slug]);
                }
            }

            return options
        },
        error: function (e) {
            console.warn(e)
        }
    })
    return options
}
export function getFieldChoices(url){
    if(url === "null" || !url){
        return [["Select a field 2", "null"]];
    }
    var options = [];
    $.ajax({
        type: "GET",
        url: url,
        success: function (data) {

            for (var i = 0; i < data.fields.length; i++) {
                if (data.fields[i].name !== undefined && data.fields[i].name !== null && data.fields[i].name !== "") {
                    options.push([data.fields[i].name, data.fields[i].slug]);
                }
            }
            return options
        },
        error: function (e) {
            console.warn(e)
        }
    })
    return options
}

export function getPalette() {
    return [
        '#4286f4',
        '#ef0447',
        '#f4b400',
        '#0f9d58',
        '#9c27b0',
        '#ff5722',
        '#795548',
        '#607d8b',
    ];
}

export function getDefinition(toolboxItem){
    return toolboxItem.toolboxItemDef_.definition
}

export function getPosition(id) {
    const categories = this.workspace_.options.languageTree.contents;
    for (let i = 0; i < categories.length; i++) {
        if (categories[i].kind === 'category' && categories[i].id === id) {
            return i;
        }
    }

    return -1;
}

export function getToolbox() {
    var ret = [];
    var response = [];
    data = $.ajax({
        async: false,
        url: '/api/blockly/toolbox-category/',
        type: 'GET',
        success: function (data) {
            response = data
        },
    })
    response.forEach(category => {
        ret.push(category.toolbox_category)
    })
    return ret
}
export function getFields() {
    var ret = [];
    var response = [];
    data = $.ajax({
        async: false,
        url: '/api/blockly/toolbox-category/',
        type: 'GET',
        success: function (data) {
            response = data
        },
    })
    response.forEach(category => {
        category.dropdown_content.forEach(field => {
            ret.push(field)
        })
    })
    return ret
}

export function saveWorkspace(workspace, user_id, name, csrf_token) {
    const state = Blockly.serialization.workspaces.save(workspace);
    var workspace_id = workspace.options.id;
    var workspace_data = {
        'json_data': state,
        'name': name,
        'id': workspace_id,
        'user': user_id,
        'code': pythonGenerator.workspaceToCode(workspace),
    };
    $.ajax({
        url: '/api/blockly/workspace/',
        type: 'POST',
        headers: {"X-CSRFToken": csrf_token},
        data: JSON.stringify(workspace_data),
        contentType: 'application/json',
    });
}
export function loadWorkspace(workspace, workspace_id) {
    $.ajax({
        url: `/api/blockly/workspace/${workspace_id}/`,
        type: 'GET',
        success: function (data) {
            Blockly.serialization.workspaces.load(data.json_data, workspace);
        }
    });
}
export function deleteWorkspace(workspace_id, csrf_token) {
    $.ajax({
        url: `/api/blockly/workspace/`+workspace_id+`/`,
        type: 'DELETE',
        headers: {"X-CSRFToken": csrf_token},
    });
}